var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"item-unit-measure",style:(_vm.style)},[_vm._v(_vm._s(_vm.item.unitMeasureDisplayOnApp))])
}
var staticRenderFns = []

export { render, staticRenderFns }